import classNames from 'classnames'
import styled from 'styled-components'

import { useBuildingContext } from '../../../../../contexts/buildingContext'
import {
  MapPointContainer,
  MapPointMainCircle,
} from '../../../../common/MapViewer'
import { IMapPoint } from '../ManagePoints/ManagedMapPoint'

import { useManageSchedulesContext } from './ManageSchedulesContext'

interface ISchedulePointProps {
  x: number
  y: number
  point: IMapPoint
  onClick: (point: IMapPoint) => void
  disabled?: boolean
  sequenceOrder?: number | null
  isSequencingMode?: boolean
  isEligibleForSequence?: boolean
}

export const SchedulePoint = ({
  point,
  x,
  y,
  onClick,
  disabled,
  sequenceOrder = null,
  isSequencingMode = false,
  isEligibleForSequence = false,
}: ISchedulePointProps) => {
  const { state: buildingState } = useBuildingContext()

  const { canCreateSchedulePointMapping, canDeleteSchedulePointMapping } =
    useManageSchedulesContext()

  const pointIsSelected: boolean = buildingState.floorData.selectedPoints.has(
    point.point_id,
  )
  const inCurrentGroup: boolean = buildingState.floorData.groupPoints.has(
    point.point_id,
  )

  const isClickable = isSequencingMode
    ? isEligibleForSequence && !disabled
    : canCreateSchedulePointMapping || canDeleteSchedulePointMapping

  return (
    <MapPointContainer
      className={`map-point mp-${point.point_id}`}
      x={x}
      y={y}
      isActive={isClickable}
      onClick={() => {
        if (isClickable) {
          onClick(point)
        }
      }}
    >
      <MapPointMainCircle
        className={classNames({
          back_pink: pointIsSelected && !disabled,
          back_pink_empty: !pointIsSelected && !disabled,
          back_gray: pointIsSelected && disabled,
          back_gray_empty: !pointIsSelected && disabled,
          back_blue: inCurrentGroup,
        })}
      />
      {sequenceOrder != null && (
        <SequenceOrderBadge>{sequenceOrder}</SequenceOrderBadge>
      )}
    </MapPointContainer>
  )
}

const SequenceOrderBadge = styled.div`
  position: absolute;
  top: -18px;
  left: 50%;
  transform: translateX(-50%);
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 9px;
  background-color: #073c7a;
  color: white;
  font-size: 10px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  pointer-events: none;
  z-index: 2;
`
